
<div>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">

        <div id="divListData">
          <button type="button" id="btnLoadList" (click)="GetDefectList()" style="display:none">Get</button>
          <div class="divContainer" style="top:-10px;" id="divMainFilter">
            <div class="row">
              <div class="col-sm-8">
                <label>Journals</label>
                <select id="lstJournals" class="form-control select2" multiple>
                  <option *ngFor="let item of journalList" value={{item.ID}}>
                    {{item.Acronym}}
                  </option>
                </select>
              </div>

              <!--<div class="col-sm-6">
                <label>Status</label>
                <select id="ddlStatus" class="form-control select2">
                  <option value="All" selected="selected">All</option>
                  <option *ngFor="let item of lStatusList" value={{item.Activity}} [selected]="item.Activity==filterStatus">
                    {{item.Activity}}
                  </option>
                </select>
              </div>-->
              <div class="col-sm-4">
                <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="GetDefectList()">Search</button>
                <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
                <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Back" (click)="BacktoDashBoard()" style="margin-left:10px">Back To DashBoard</button>
              </div>

            </div>
          </div>

          <div id="divDataList">
            <button type="button" id="btnAddNew" class="btn btn-block btn-primary float-sm-right" (click)="ShowInfoPopUp()" style="display:none">Add New</button>
            <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="ShowDataResponse()" style="display:none"></button>
            <table #dataTable class="display" style="width:100%;"></table>
          </div>

        </div>


        <div id="DivAddData" class="modal myModalView" style="display:none">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)=" BacktoDashBoard()">&times;</button>
              </div>
              <div class="modal-body">
                <div class="card">
                  <div class="card-body">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-sm-2">
                          <label>Journal</label><span class="required">*</span>
                          <select id="ddlJournals" class="form-control ddlselect" onchange="$('#btnGetVolIssArt').trigger('click');">
                            <option value=0>Select</option>
                            <option *ngFor="let item of journalList" value={{item.ID}}>
                              {{item.Acronym}}
                            </option>
                          </select>
                        </div>

                        <div class="col-sm-2">
                          <label>Issue</label>
                          <select id="ddlIssue" class="form-control ddlselect">
                            <option value=0>Select</option>
                            <option *ngFor="let item of issueList" value={{item.IssueId}}>
                              {{item.VolIssue}}

                            </option>
                          </select>
                        </div>

                        <div class="col-sm-2">
                          <label>Article</label>
                          <select id="ddlArticle" class="form-control ddlselect">
                            <option value=0>Select</option>
                            <option *ngFor="let item of articleList" value={{item.ArticleId}}>
                              {{item.ArticleNo}}
                            </option>
                          </select>
                        </div>
                      </div>

                      <br /><hr /><br />

                      <div class="row">
                        <div class="col-sm-4">

                          <button type="button" id="btnDefectCategory" (click)="GetDefectCategoryList()" style="display:none">
                            Get
                          </button>

                          <label>Defect Area</label><span class="required">*</span>
                          <select id="ddlDefectArea" class="form-control ddlselect" onchange="$('#btnDefectCategory').trigger('click');">
                            <option value=0>Select</option>
                            <option *ngFor="let item of DefectAreaList" value={{item.Id}}>
                              {{item.AreaName}}
                            </option>
                          </select>
                        </div>

                        <div class="col-sm-3">
                          <label>Defect Category</label><span class="required">*</span>
                          <select id="ddlDefectCategory" class="form-control ddlselect">
                            <option *ngFor="let item of DefectCategoryList" [selected]="item.Id==CategoryIdPop" value={{item.Id}}>
                              {{item.Category}}
                            </option>
                          </select>
                        </div>

                        <div class="col-sm-5">
                          <label>Defect Instruction</label><span class="required">*</span>
                          <select id="ddlDefectInstruction" class="form-control ddlselect">
                            <option value=0>Select</option>
                            <option *ngFor="let item of DefectInstructionList" value={{item.Id}}>
                              {{item.Instructions}}
                            </option>
                          </select>
                        </div>

                        <!--<div class="col-sm-2">
                          <label>Request RCA</label>
                          <select id="ddlFeedbackRequest" class="form-control ddlselect">
                            <option value=0>No</option>
                            <option value=1>Yes</option>
                          </select>
                        </div>-->


                        <div class="row">
                          <div class="col-sm-6" id="testfileuploadbtn" style="padding: 20px;">
                            <label>Defect File</label><br />
                            <input type="file" class="form-control" (change)="onuploadSelected($event)" id="doc_Defectuploadfile" />
                          </div>

                          <div class="col-sm-6">
                            <br />
                            <label>Defect Due Date</label><span class="required">*</span>
                            <input type="date" class="form-control float-right" id="Txt_DefectDueDate" (change)="GetDueDateValidation()" [min]="minDate" [max]="maxDate">
                          </div>

                        </div>

                        <div class="row">
                          <div class="col">
                            <label>Defect Description</label><span class="required">*</span>
                            <textarea class="form-control rounded-0" id="txtDescription"></textarea>
                          </div>
                        </div><br /><br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer" id="textbuttonh">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" (click)="BacktoDashBoard()" id="">Cancel</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateDefectMgt()" id="UpdateAdd">{{popUpButtonText}}</button>
              </div>

            </div>
          </div>

        </div>


        <div id="divResponseData" class="modal myModalView" style="display:none">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{Response}}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="BacktoDashBoard()">&times;</button>
              </div>

              <div class="modal-body DetailScroll">
                <div class="row">
                  <div class="col-sm-4" id="tbldefectmanagement">
                    <br />
                    <table class="tblBkinfo tblMain table table-bordered" width="100%">
                      <tbody>
                        <tr>
                          <td class="main"><b>Journal</b></td>
                          <td>{{Acronym}}</td>
                        </tr>

                        <tr>
                          <td class="main"><b>Issue</b></td>
                          <td>{{VolIssue}}</td>
                        </tr>

                        <tr>
                          <td class="main"> <b>Article</b></td>
                          <td>{{ArticleNo}}</td>
                        </tr>
                        <tr>
                          <td class="main"> <b>Defect Area</b></td>
                          <td>{{AreaName}}</td>
                        </tr>
                        <tr>
                          <td class="main"> <b>Defect Category</b></td>
                          <td>{{Category}}</td>
                        </tr>
                        <tr>
                          <td class="main"><b>Defect Instruction</b></td>
                          <td>{{Instructions}}</td>
                        </tr>
                        <tr>
                          <td class="main"><b>Defect Due Date</b></td>
                          <td>{{DefectDueDate}}</td>
                        </tr>
                        <tr>
                          <td class="main"><b>Defect File</b></td>
                          <td>
                            <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="Download" (click)="DefectDownloadFile()"><i class="fa fa-download"></i><b>Support File</b></button>
                          </td>
                        </tr>

                        <tr>
                          <td class="main"> <b> Description</b></td>
                          <td><div class="description">{{Description}}</div></td>
                        </tr>
                        <tr>
                          <td class="main"><b>Corrected File </b></td>
                          <td>
                            <button type="button" class="btn btn-outline-primary waves-effect waves-light" id="DownloadCorrectFile" (click)="DefectCorrectedFile()"><i class="fa fa-download"></i><b>Correction Defect File</b></button>&nbsp;
                          </td>
                        </tr>
                        <tr>
                          <td class="main"><b>RootCause User</b></td>
                          <td><input id="Txt_RootCauseuser" type="text" class="form-control" maxlength="40" /></td>
                        </tr>
                        <tr>
                          <td class="main"><b>Responsible User</b></td>
                          <td><input id="Txt_ResponsibleUser" type="text" class="form-control" maxlength="40" /></td>
                        </tr>
                        <tr>
                          <td class="main"><b>Complaint Type</b></td>
                          <td>
                            <select id="ddlComplaintType" class="form-control ddlselect">
                              <option value="0">Select</option>
                              <option value=0>External</option>
                              <option value=1>Internal</option>
                            </select>
                          </td>

                        </tr>
                        <tr>
                          <td class="main"><b>Critical Level</b></td>
                          <td>
                            <select id="ddlCriticalLevel" class="form-control ddlselect">
                              <option value="0">Select</option>
                              <option value=1>Low</option>
                              <option value=2>Medium</option>
                              <option value=3>High</option>
                            </select>
                          </td>
                        </tr>


                      </tbody>
                    </table>
                  </div>
                  <div class="col-sm-8" id="">
                    <div class="row">
                      <div class="col-6" id="defcorrectuploadbtn">
                        <label>Defect Corrected File:</label><br />
                        <input type="file" id="doc_DefectCorrectedFile" class="form-control" (change)="onuploadDataSelected($event)" /><br />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <label>Root Cause</label><span class="required">*</span>
                        <textarea class="form-control rounded-0" id="Txt_rootCause" rows="7" autocomplete="off" style="resize:none"></textarea>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <label>Preventive Action</label><span class="required">*</span>
                        <textarea class="form-control rounded-0" id="Txt_PreventiveAction" rows="6" autocomplete="off" style="resize:none"></textarea>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col">
                        <label>Corrective Action</label><span class="required">*</span>
                        <textarea class="form-control rounded-0" id="Txt_CorrectiveAction" rows="7" autocomplete="off" style="resize:none"></textarea>
                      </div>
                    </div>
                    <br />

                    <div class="row" id="Status">
                      <div class="col-sm-6">
                        <label>Defect Status</label>
                        <select id="DefectStatus" class="form-control ddlselect">
                          <option value="Reject">Reject</option>
                          <option value="Approve">Approve</option>
                        </select>
                      </div>
                    </div>
                    
                    <div class="row" id="DefectComments">
                      <div class="col">
                        <label>Comments</label>
                        <textarea class="form-control" id="txtDefectResponse" style="resize:none" autocomplete="off" rows="6"> </textarea>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" (click)="BacktoDashBoard()" id="Close">Cancel</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="UpdateDefectMgtResponse()" id="UpdateIcon">{{popUpButtonText}}</button>
              </div>
            </div>
          </div>
          <div id="LoadingImage">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
